var path = '/app/components/dialogs/forms/forms.html';
var html = "<div class=intervencional-modal-wrap style=\"background-image:url('{{ $ctrl.bg }}')\"> <div class=modal-body> <div class=parts> <img ng-src=\"{{ $ctrl.pictures }}\" class=part> </div> <p class=parts-text> Você ganhou <b>9 pacotes</b> de figurinhas. </p> <a class=btn-confirm ng-click=$ctrl.ok()></a> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dialogs/forms/forms.html
// module id = 218
// module chunks = 0